<template>
    <span
        :class="{
            'chip-emerald': status === 'pre-approved' || status === 'approved',
            'chip-rose': status === 'reproved',
            'chip-amber': status === 'pending',
            'chip-slate': status === 'draft',
            'chip-orange': status === 'pending-correction',
        }"
    >
        {{ statusName }}
    </span>
</template>

<script>
export default {
    props: ["status"],

    computed: {
        statusName() {
            switch (this.status) {
                case "draft":
                    return "Rascunho";
                case "approved":
                    return "Aprovado";
                case "pre-approved":
                    return "Pré Aprovado";
                case "reproved":
                    return "Reprovado";
                case "pending":
                    return "Pendente";
                case "pending-correction":
                    return "Correção Pendente";
                default:
                    return this.status;
            }
        },
    },
};
</script>
